import {
  type ChatAnalytics,
  type ChatAnalyticsConfigs,
  createChatAnalytics as createCoreChatAnalytics,
} from '@flowx/core-sdk'

/**
 * Component events of a chat, shared by both Angular chat stacks. flx-chat sends a configured
 * prompt through `sendMessage`, right after `promptSelected` in the same task: that text message
 * does not count. The skip ends with the task, so a prompt whose send fails (for example before the
 * chat is initialized) cannot swallow the next typed message.
 */
export function createChatAnalytics(configs: () => ChatAnalyticsConfigs): ChatAnalytics {
  const analytics = createCoreChatAnalytics(configs)
  let promptMessagePending = false

  return {
    ...analytics,
    textMessageSent: () => {
      if (promptMessagePending) {
        promptMessagePending = false
        return
      }
      analytics.textMessageSent()
    },
    configuredPromptSelected: (label) => {
      promptMessagePending = true
      queueMicrotask(() => {
        promptMessagePending = false
      })
      analytics.configuredPromptSelected(label)
    },
  }
}
